import Storage from './../../services/Storage'

export const shipperLocalStorage = (listShipper, shipperId) => {
    if(!listShipper.length) return
    listShipper.map((e, i) => {
        e.count_shipper = listShipper.length
        if(e.ShipperId === shipperId) {
            Storage.set('shipper_active', e)
        }
        return false;
    })
}


// WEBPACK FOOTER //
// ./src/containers/switch-shipper/helper.js